import { KestrelViewerMessageCallbackAPI } from 'features/kestrelViewer'
import {
  KVAnnotation,
  KVInspectionArea,
  RolodexEntryPatchJson,
  WorldPosition,
} from 'types'

import { KVMessageDef } from './index'

export function getNewInspectionAreaBatchMessage() {
  return {
    type: 'newInspectionAreaBatch',
    requiredData: ['items'],

    callback: (
      json: Record<string, unknown>,
      kv: KestrelViewerMessageCallbackAPI
    ) => {
      const inspectionAreas: KVInspectionArea[] = []
      const items = (json.items as Array<Record<string, unknown>>) ?? []

      for (const value of items) {
        inspectionAreas.push(KVInspectionArea.fromJSON(value))
      }

      const updatedInspectionAreas: KVInspectionArea[] = kv.inspectionAreas
        ? [...kv.inspectionAreas, ...inspectionAreas]
        : inspectionAreas

      kv.setInspectionAreas(updatedInspectionAreas)
      const data: Record<string, unknown> = {
        inspectionAreas:
          updatedInspectionAreas?.map((ia) => KVInspectionArea.toJSON(ia)) ??
          [],
      }

      if (json.segments) {
        data.boundingSegments = json.segments as WorldPosition[]
      }

      let annotations = kv.annotations ? [...kv.annotations] : undefined

      if (
        annotations &&
        (json.markupToInspectionArea || json.surfaceAreaToInspectionArea)
      ) {
        const surfaceAreaToInspectionArea: Record<string, string> =
          (json.surfaceAreaToInspectionArea || {}) as Record<string, string>
        const markupToInspectionArea: Record<string, string> =
          (json.markupToInspectionArea || {}) as Record<string, string>

        annotations = annotations.map((annotation) => {
          if (surfaceAreaToInspectionArea[annotation.id]) {
            annotation.tags['inspectionArea'] = {
              derivedTag: true,
              value: surfaceAreaToInspectionArea[annotation.id],
            }
          } else if (markupToInspectionArea[annotation.id]) {
            annotation.tags['inspectionArea'] = {
              derivedTag: true,
              value: markupToInspectionArea[annotation.id],
            }
          }

          return annotation
        })

        kv.setAnnotations(annotations)
        data['annotations'] = annotations.map((a) => KVAnnotation.toJSON(a))
      }

      if (kv.kestrelModel?.id) {
        // Track inspection area in rolodex
        const patchData: RolodexEntryPatchJson = {
          id: kv.kestrelModel.id,
          data: data,
        }
        kv.rolodexPatch([patchData])
      }
    },
  } as KVMessageDef
}
